import {
  LayoutColumnsDefinition,
  LayoutListDefinition,
  LAYOUT_COLUMNS,
  LAYOUT_LIST,
  TEXT,
  PHONE,
  VideoDefinition,
  PhoneDefinition,
  VIDEO,
  QUIZ_INSTA
} from '../items';
import { Translator } from '../Translator';
import { translate } from './translate';
import { isIOS, isSafari } from 'react-device-detect';

export const QuizInsta: Translator = sequence => {
  const columns = {
    type: LAYOUT_COLUMNS,
    id: `${sequence.id}-columns`,
    items: [],
    values: {}
  } as LayoutColumnsDefinition;

  const root = translate(sequence, item => {
    switch (item.__typename) {
      case 'Question':
        columns.items.push({
          id: item.id,
          type: LAYOUT_LIST,
          values: { align: 'left', height: { _: 'auto', lg: '100%' } },
          items: [
            {
              id: `${item.id}-insta`,
              type: QUIZ_INSTA,
              values: {
                title: item?.title,
                name: item?.subtitle,
                picture: item.pictures && item?.pictures[0],
                questions: item?.items
              },
              items: [
                {
                  type: PHONE,
                  id: item.id,
                  values: {
                    personalization: sequence.personalization
                  },
                  items: item.videos?.length
                    ? [
                        {
                          type: VIDEO,
                          id: `${item.id}-video`,
                          values: {
                            isolated: false,
                            showPlayButton: true,
                            autoPlay: false,
                            mediaUrl:
                              isIOS || isSafari
                                ? ([
                                    item.videos[0].mediaUrl && {
                                      src: item.videos[0].mediaUrl,
                                      type: 'video/mp4'
                                    }
                                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                                  ].filter(Boolean) as any)
                                : ([
                                    item.videos[0].hlsUrl && {
                                      src: item.videos[0].hlsUrl,
                                      type: 'application/vnd.apple.mpegurl'
                                    },
                                    item.videos[0].mediaUrl && {
                                      src: item.videos[0].mediaUrl,
                                      type: 'video/mp4'
                                    }
                                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                                  ].filter(Boolean) as any),
                            subtitlesUrl: item.videos[0].subtitlesUrl || '',
                            snapshotUrl: item.videos[0].snapshotUrl || ''
                          }
                        } as VideoDefinition
                      ]
                    : []
                } as PhoneDefinition
              ]
            }
          ]
        } as LayoutListDefinition);
        break;

      case 'Text':
        columns.items.push({
          id: item.id,
          type: LAYOUT_LIST,
          values: { align: 'right', height: { _: 'auto', lg: '100%' } },
          items: [
            {
              type: TEXT,
              id: `${item.id}_subtitle`,
              items: [],
              values: {
                value: item.subtitle,
                variant: 'sub_heading',
                icon: item.icon
              }
            },
            {
              type: TEXT,
              id: `${item.id}_title`,
              items: [],
              values: {
                value: item.title,
                variant: 'heading1'
              }
            },
            {
              type: TEXT,
              id: `${item.id}_body`,
              items: [],
              values: {
                value: item.body
              }
            }
          ]
        } as LayoutListDefinition);
        break;
    }
    return null;
  });

  root.items.push(columns);
  return root;
};
